exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".images{display:flex;flex-wrap:wrap;margin:2px;border:\"1px solid grey\"}.images .img,.images .pic{flex-basis:31%;margin:2px;border-radius:4px;border:\"1px solid grey\"}.images .img{width:112px;height:93px;background-size:cover;margin-right:2px;background-position:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;position:relative;overflow:hidden;border:\"1px solid gainsboro\"}.images .img:nth-child(3n){margin-right:0}.images .img:after{content:\"\";width:100%;height:100%;transition:opacity .1s ease-in;border-radius:4px;opacity:0;position:absolute}.images .img:hover:after{display:block;background-color:#000;opacity:.5}.images .img:hover span{display:block;color:#fff}.images .pic{background-color:#f5f7fa;align-self:center;text-align:center;padding:40px 0;text-transform:uppercase;color:#848ea1;font-size:12px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/components/Screens/FieldsComponents/PhotoUpload/photo.css
// module id = 373
// module chunks = 0